import { Allotment } from 'allotment';
import 'allotment/dist/style.css';

export type SplitPanelProps = {
  panes: any[];
  setSizes: any;
  isDesktop: boolean;
};

export default function MapSplitPane({
  panes,
  setSizes,
  isDesktop,
}: SplitPanelProps) {
  return isDesktop ? (
    <Allotment
      data-testid="map-split-pane"
      vertical={false}
      onChange={setSizes}
    >
      {panes}
    </Allotment>
  ) : (
    <>{panes}</>
  );
}
